module.exports = __webpack_public_path__ + "media/custom/images/img8-605807b9febb4ea5c53e3bed9d13cecb.png";